import { render, staticRenderFns } from "./mandatory.vue?vue&type=template&id=4ac8daa8&scoped=true&"
import script from "./mandatory.vue?vue&type=script&lang=js&"
export * from "./mandatory.vue?vue&type=script&lang=js&"
import style0 from "./mandatory.vue?vue&type=style&index=0&id=4ac8daa8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac8daa8",
  null
  
)

export default component.exports